export class TreeItemNode {
  children: TreeItemNode[];
  value: string;
  viewValue: string;
  code: string;
  desc: string;
  status: boolean;
  childNodes?: string[];
}
